import React from 'react';

import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { Flex, UiButton, UiText } from '@shared/ui';

import cls from './NewFeatureChip.module.css';

interface INewFeatureChipProps {
    className?: string;
    onClose: () => void;
}
export const NewFeatureChip = ({ className, onClose }: INewFeatureChipProps) => {
    const { t } = useTranslation();

    return (
        <Flex className={cn(cls.NewFeatureChipOverlay, className)}>
            <Flex
                className={cn(cls.NewFeatureChipDescriptionContainer)}
                direction="column"
                gap={24}
            >
                <Flex direction="column" gap={12}>
                    <UiText
                        variant="subHeading"
                        weight="bold"
                        align="left"
                        className={cls.NewFeatureChipDescriptionHeader}
                    >
                        {t('Checklist.NewFeatureChip.header')}
                    </UiText>
                    <UiText
                        variant="plain"
                        align="left"
                        className={cls.NewFeatureChipDescriptionText}
                    >
                        {t('Checklist.NewFeatureChip.description')}
                    </UiText>
                </Flex>
                <UiButton
                    className={cls.NewFeatureChipBtn}
                    btnText={t('button.got_it.text')}
                    onClick={onClose}
                />
            </Flex>
        </Flex>
    );
};
